const version = process.env.VERSION || '7.3.15';
const mode = process.env.NWF || '';
const finalVersion = version + mode;
module.exports = finalVersion;
